import React from "react";
import { snakeToCamel } from "utils/caseConvertor";
import {
  TextField,
  Dropdown,
  MultiselectDropdown,
  RadioButtonGroup,
} from "../../Components";

interface SampleProps {
  panel: any; // replace 'any' with the appropriate type for the 'panel' prop'
  editMode: boolean;
  formikProps: any;
  handleUpdateStatus: any;
}

const Sample: React.FC<SampleProps> = ({ panel, editMode, formikProps, handleUpdateStatus }) => {

  const onChange = (eleName: string, value: any, name: string) => {
    formikProps.setFieldValue(eleName, value)
    handleUpdateStatus(name, panel.sectionId)
  }

  const panelElements =
    panel.templateElements && panel.templateElements.length > 0
      ? panel.templateElements
      : panel.elements && panel.elements.length > 0
        ? panel.elements
        : [];

  const panelName = snakeToCamel(panel.name);

  return (
    <>
      <div className="grid grid-cols-12 gap-4 mb-5">
        {panelElements.map((element: any, index: number) => {
          const {
            name,
            title,
            choices,
            fieldAs,
            rows,
            inputType,
            type,
            placeholder,
            choicesByUrl,
            isRequired = false,
            visible = true,
          } = element;
          const eleName = [panelName, element.name].join(".");
          const error = formikProps.errors[panelName]?.[element.name];
          const touched = formikProps.touched[panelName]?.[name];
          if (visible === false || type === "html") {
            return;
          }
          switch (element.type) {
            case "text":
              return (
                <div
                  className={`${name === "SampleAmount" ||
                      name === "TissueRemovalTime" ||
                      name === "TissueFrozenTime"
                      ? "col-span-6"
                      : "col-span-12"
                    }`}
                >
                  <TextField
                    key={index}
                    label={title}
                    type={inputType || type}
                    name={name}
                    value={formikProps.values[panelName]?.[name]}
                    fieldAs={fieldAs}
                    rows={rows}
                    editMode={editMode}
                    handleChange={(value: any) =>
                      onChange(eleName, value, name)
                    }
                    handleBlur={() =>
                      formikProps.setFieldTouched(eleName, true, true)
                    }
                    placeholder={placeholder || `Enter ${title}`}
                    required={isRequired}
                    error={error}
                    touched={touched}
                    panel={panel}
                    element={element}
                  />
                </div>
              );

            case "dropdown":
              return (
                <div
                  className={`${name === "AmountUnits" ? "col-span-6" : "col-span-12"
                    }`}
                >
                  <Dropdown
                    key={index}
                    label={title}
                    name={name}
                    choices={choices}
                    value={formikProps.values[panelName]?.[name]}
                    handleChange={(item: any) =>
                      onChange(eleName, item, name)
                    }
                    handleBlur={() =>
                      formikProps.setFieldTouched(eleName, true, true)
                    }
                    editMode={editMode}
                    choicesByUrl={choicesByUrl}
                    placeholder={placeholder || `Select ${title}`}
                    required={isRequired}
                    error={error}
                    touched={touched}
                    panel={panel}
                    element={element}
                  />
                </div>
              );

            default:
              return null; // Or render a default component for unknown types
          }
        })}
      </div>
    </>
  );
};

export default Sample;
